module.exports = __webpack_public_path__ + "static/media/determinacao.b25ca21f.jpg";